import { FileWithPath } from 'file-selector';
import moment from 'moment';
import api from '.';
import { ApprovalCode } from '../pages/MasterData/ApprovalCode/approvalCodeSlice';

export interface UserApprovalWithFile {
  id: number | null;
  approvalTypeId: number | null;
  comment: string | null;
  approvalCode: ApprovalCode | null;
  isChecked: boolean;
  checklistLinkUrl: string | null;
  files: { file: FileWithPath; fileTypeId: number }[];
}

interface UserApprovalWithFileAndId extends UserApprovalWithFile {
  id: number;
  approvalTypeId: number;
}

interface MyTaskHistoryParams {
  page: number;
  limit: number;
  search?: string | null;
  projectIds: number[];
  purposeIds: number[];
}

export async function getMyTaskHistory(params: MyTaskHistoryParams) {
  const { data } = await api.get('/user-approvals/history', {
    params
  });
  return data;
}

export async function submitCommentApproval(
  userApprovalWithFile: UserApprovalWithFileAndId
) {
  const formData = new FormData();
  userApprovalWithFile.files.forEach(({ file, fileTypeId }) => {
    formData.append('files', file);
    formData.append('fileTypeIds', fileTypeId.toString());
  });

  formData.append(
    'approvalTypeId',
    userApprovalWithFile.approvalTypeId.toString()
  );
  if (userApprovalWithFile.comment) {
    formData.append('comment', userApprovalWithFile.comment.toString());
  }
  if (userApprovalWithFile.approvalCode) {
    formData.append(
      'approvalCodeId',
      userApprovalWithFile.approvalCode.id.toString()
    );
  }
  formData.append('submittedDate', moment().format().toString());
  formData.append('isChecked', userApprovalWithFile.isChecked.toString());
  if (userApprovalWithFile.checklistLinkUrl) {
    formData.append('checklistLinkUrl', userApprovalWithFile.checklistLinkUrl);
  }

  const { data } = await api.put(
    `/user-approvals/${userApprovalWithFile.id}/checklists`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}
